import { type ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

const variants = {
  // Kordaro v4: primair = merkvlak, secundair = wit met merkrand, geen opacity voor disabled.
  primary: 'bg-brand hover:bg-brand-dark text-[var(--brand-on-primary,#F7F2EC)] border border-brand disabled:bg-gray-200 disabled:border-gray-200 disabled:text-gray-600',
  secondary: 'bg-white hover:bg-brand-light text-brand border border-brand disabled:bg-gray-50 disabled:text-gray-600 disabled:border-gray-200',
  danger: 'bg-[#9F2936] hover:bg-[#7F2029] text-white border border-[#9F2936] disabled:bg-gray-200 disabled:border-gray-200 disabled:text-gray-600',
  ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 border border-transparent',
};

const sizes = {
  sm: 'min-h-[36px] px-3 py-1.5 text-sm',
  md: 'min-h-[44px] px-4 py-2 text-sm',
  lg: 'min-h-[48px] px-5 py-2.5 text-base',
};

export function Button({ variant = 'primary', size = 'md', className, children, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center font-semibold rounded-lg transition-colors disabled:cursor-not-allowed gap-2',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
